var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.333 234.667c-96.624 0-117.333-20.709-117.333-117.334 0-96.624 20.709-117.333 117.333-117.333 96.625 0 117.333 20.709 117.333 117.333.001 96.625-20.708 117.334-117.333 117.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.333 512c-96.624 0-117.333-20.71-117.333-117.333 0-96.625 20.709-117.333 117.333-117.333 96.625 0 117.333 20.708 117.333 117.333.001 96.623-20.708 117.333-117.333 117.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.333 394.667c0 96.623 20.709 117.333 117.334 117.333s117.333-20.71 117.333-117.333c0-96.625-20.708-117.333-117.333-117.333s-117.334 20.708-117.334 117.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416 42.667c0-11.782-9.551-21.333-21.333-21.333s-21.333 9.551-21.333 21.333v53.333h-53.334c-11.782 0-21.333 9.551-21.333 21.333s9.551 21.333 21.333 21.333h53.333v53.334c0 11.782 9.551 21.333 21.333 21.333s21.333-9.551 21.333-21.333v-53.333h53.333c11.782 0 21.333-9.551 21.333-21.333s-9.549-21.334-21.332-21.334h-53.333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.33e885d338f1beb80b0b5dd2e7b2ed79.svg";
export { ForwardRef as ReactComponent };